import { createSelector } from 'reselect';

const selectMessage = (state) => state.message;

export const selectMessageValue = createSelector(
  [selectMessage],
  (message) => message.value
);

export const selectMessageType = createSelector(
  [selectMessage],
  (message) => message.type
);

export const selectMessageSubject = createSelector(
  [selectMessage],
  (message) => message.subject
);

export const selectMessageTemplateId = createSelector(
  [selectMessage],
  (message) => message.id
);

export const selectMessageHtml = createSelector(
  [selectMessage],
  (message) => message.html
);

export const selectMessageData = createSelector(
  [selectMessage],
  (message) => message.messageData
);
